<ng-container *ngIf="this.data.facts.length > 0 || this.data.versions.length > 0">

  <div class="all">

    <div class="left-side">
      <svg class="svg">
        <g class="main" [attr.transform]="'translate(' + 30 + ',' + (fullScreen?10:5) + ')'">
          <g class="y-axis">
            <g class="y" *ngFor="let y of yArr; let i = index">
              <text class="text-y" [ngClass]="{'text-60':fullScreen}" [attr.x]="-30" [attr.y]="((yLength*i)+4) + '%'">{{y}}%</text>
            </g>
          </g>
          <g>
            <line [attr.x1]="0" [attr.y1]="0" [attr.x2]="0" [attr.y2]="96+'%'"></line>
          </g>
        </g>
      </svg>
    </div>

    <div class="block" #box id="box">
      <svg width="100%" height="100%">
        <g class="main" [attr.transform]="'translate(' + 30 + ',' + (fullScreen?30:15) + ')'">

          <g class="y-axis">
            <g class="y" *ngFor="let y of yArr; let i = index">
              <line [attr.x1]="0" [attr.y1]="(yLength*i)+'%'" [attr.x2]="100+'%'" [attr.y2]="(yLength*i)+'%'"></line>
            </g>
          </g>

          <g class="x-axis" *ngIf="xDates.length > 0">
            <g *ngFor="let x of xDates; let i = index">
              <line [attr.x1]="(i*xLength + xLength/2)" [attr.y1]="0" [attr.x2]="(i*xLength + xLength/2)" [attr.y2]="91+'%'"></line>
              <line class="transformDate-line" *ngIf="x?.transformDate" [attr.x1]="(i*xLength + xLength/2)" [attr.y1]="91+'%'" [attr.x2]="(i*xLength + xLength/2)" [attr.y2]="92+'%'"></line>
              <text class="text-month"
                [ngClass]="[fullScreen?'text-60':'']"
                [attr.x]="((i*xLength + xLength/2))+(x.position === 'first' ? 0 : (fullScreen ? -30 : -20))+(x.position === 'last' ? -30 : 0)"
                [attr.y]="95+'%'"> {{ x?.transformDate }} </text>
            </g>
          </g>

          <g class="fact" *ngIf="factsFlag">
            <g *ngIf="!factLengthOne" class="fact-line" [attr.transform]="'translate('+ (xLength/2) + ',' +'0)'">
              <path [attr.d]="factPath" [attr.stroke]="'yellow'" [attr.stroke-width]="fullScreen ? 4 : 2" fill="transparent"></path>
            </g>

            <g *ngIf="factLengthOne" class="fact-line" >
              <circle class="circle-yellow" [attr.cx]="getPointsVersions2(facts[0].factDate) + xLength/2" [attr.y]="getYByValue(facts[0].completionPercent)" [attr.r]="fullScreen?5:3"></circle>
            </g>
          </g>

          <g class="is-lag" *ngIf="isLag">
            <g class="for-forecast">
              <g class="forecast-line" >
                <line class="line-yellow"
                  [attr.x1]="forecastLinePoints?.x1" [attr.y1]="forecastLinePoints?.y1"
                  [attr.x2]="forecastLinePoints?.x2" [attr.y2]="forecastLinePoints?.y2"
                  [attr.stroke-dasharray]="12" [attr.stroke-width]="fullScreen ? 3 : 1"></line>
              </g>
            </g>

            <g class="lates-line-fact-plan-circle">
              <circle id="circle-hover" class="circle-yellow" [attr.cx]="forecastLinePoints?.x1" [attr.cy]="forecastLinePoints?.y1" [attr.r]="fullScreen?5:3"></circle>
            </g>

            <g class="sum-all-back-days">
              <text *ngIf="forecastDate" class="text-yellow" [attr.x]="ots3" [attr.y]="-6">
                Отставание на {{sumOfBackLogDays}} дней. Прогноз завершения {{forecastDate}}
              </text>
            </g>
          </g>

          <g class="none-is-lag" *ngIf="!isLag">
            <g class="lead-text">
              <text *ngIf="totalLag < 0" class="text-yellow" [attr.x]="ots3" [attr.y]="-6">
                Опережение на {{ totalLag | numberAbs }} дней. Завершилось {{forecastDate}}
              </text>
              <text *ngIf="totalLag == 0" class="text-yellow" [attr.x]="ots3" [attr.y]="-6">
                Завершен в срок. Срок завершения {{forecastDate}}
              </text>
              <text *ngIf="totalLag > 0" class="text-yellow" [attr.x]="ots3" [attr.y]="-6">
                Отставание на {{ totalLag }} дней. Завершилось {{forecastDate}}
              </text>
            </g>
          </g>

          <g class="tooltips" #tooltips [attr.transform]="'translate('+ (xLength/2) + ',' +'0)'">

            <g class="tooltip" *ngFor="let point of points; let i = index" [ngClass]="{last: i === (points.length-1)}" (click)="getBuildingLevelStagesInfo(i)">
              <line class="line-grey" [attr.x1]="point?.x" [attr.x2]="point?.x" [attr.y1]="0" [attr.y2]="91+'%'" stroke="#FFF" [attr.stroke-width]="fullScreen ? 1 : 0.5"></line>
              <line class="line-grey" [attr.x1]="0" [attr.x2]="100+'%'" [attr.y1]="point?.y" [attr.y2]="point?.y" stroke="#FFF" [attr.stroke-width]="fullScreen ? 1 : 0.5"></line>
              <circle class="circle" [attr.cx]="point?.x" [attr.cy]="point?.y" [attr.stroke]="'#F1CC31'" [attr.stroke-width]="fullScreen?3:2" [attr.r]="fullScreen?8:5"></circle>
              <circle class="circle" [attr.cx]="point?.x" [attr.cy]="point?.y" fill="#F1CC31" [attr.r]="fullScreen?5:3"></circle>

              <g [attr.transform]="getRectPosition(point?.x, point?.y)">

                <rect class="tooltip-rect" [attr.x]="point?.x" [attr.y]="point?.y" [attr.height]="fullScreen?120:60" [attr.width]="fullScreen?350:210" rx="3" ry="3" [attr.fill]="point?.difference > 0 ? 'red' : 'green'"></rect>

                <g transform="translate(0 15)">
                  <text class="tooltip-text fz-80" [attr.x]="point?.x" [attr.y]="point?.y" [attr.dy]="fullScreen?55:20" [attr.dx]="fullScreen?270:165"
                    text-anchor="right">{{point?.value | numberWitoutRounding}}%</text>
                  <!-- <text class="tooltip-text" [attr.x]="point?.x" [attr.y]="point?.y" [attr.dy]="fullScreen?20:0" [attr.dx]="fullScreen?10:5"
                    text-anchor="start">План:</text>
                  <text class="tooltip-text" [attr.x]="point?.x" [attr.y]="point?.y" [attr.dy]="fullScreen?20:0" [attr.dx]="fullScreen?135:80"
                    text-anchor="start">{{point?.planDate | dateFormat}}</text> -->
                  <text class="tooltip-text" [attr.x]="point?.x" [attr.y]="point?.y" [attr.dy]="fullScreen?42:10" [attr.dx]="fullScreen?10:5"
                    text-anchor="start">Факт:</text>
                  <text class="tooltip-text" [attr.x]="point?.x" [attr.y]="point?.y" [attr.dy]="fullScreen?42:10" [attr.dx]="fullScreen?135:80"
                    text-anchor="start">{{point?.date | dateFormat}} </text>
                  <text class="tooltip-text" [attr.x]="point?.x" [attr.y]="point?.y" [attr.dy]="fullScreen?72:28" [attr.dx]="fullScreen?10:5">
                    {{point?.difference >= 0 ? 'Отставание' : 'Опережение'}}:
                  </text>
                  <text class="tooltip-text" [attr.x]="point?.x" [attr.y]="point?.y" [attr.dy]="fullScreen?72:28" [attr.dx]="fullScreen?135:80"
                    text-anchor="start">
                    {{point?.difference | numberAbs}} дней
                  </text>
                </g>

              </g>
            </g>
          </g>

          <!-- <g class="versions" *ngIf="versionsFlag">
            <g>
              <path [attr.d]="factPath2" [attr.stroke]="'white'" [attr.stroke-width]="fullScreen ? 4 : 2" fill="transparent"></path>
            </g>
            <g *ngFor="let point of points2; let i = index">
              <circle class="circle" [attr.cx]="point?.x" [attr.cy]="point?.y" [attr.fill]="'#FFFFFF'"
              [attr.r]="fullScreen?5:3"></circle>

              <g id="hover-tooltip-first">
                <circle [attr.stroke]="'#FFFFFF'" [attr.cx]="point?.x" [attr.cy]="point?.y"
                  [attr.stroke-width]="fullScreen?3:2" [attr.r]="fullScreen?8:5"></circle>
                <circle [attr.cx]="point?.x" [attr.cy]="point?.y" [attr.fill]="'#FFFFFF'"
                  [attr.r]="fullScreen?5:3"></circle>
                <g transform="translate(10,0)">
                  <rect class="tooltip-rect" [attr.x]="point?.x" [attr.y]="point?.y" [attr.height]="fullScreen?70:40"
                    [attr.width]="fullScreen?260:160" rx="3" ry="3"></rect>
                  <g transform="translate(2, 3)">
                    <text class="tooltip-text" [attr.x]="point?.x" [attr.y]="75+'%'" [attr.dy]="fullScreen?25:12"
                      [attr.dx]="fullScreen?10:5" text-anchor="start">Дата начало:</text>
                    <text class="tooltip-text" [attr.x]="point?.x" [attr.y]="75+'%'" [attr.dy]="fullScreen?25:12"
                      [attr.dx]="fullScreen?130:80" text-anchor="start">{{ v.planStartDate | dateFormat}}</text>
                    <text class="tooltip-text" [attr.x]="point?.x" [attr.y]="75+'%'" [attr.dy]="fullScreen?45:30"
                      [attr.dx]="fullScreen?10:5" text-anchor="start">Дата конца:</text>
                    <text class="tooltip-text" [attr.x]="point?.x" [attr.y]="75+'%'" [attr.dy]="fullScreen?45:30"
                      [attr.dx]="fullScreen?130:80" text-anchor="start">{{v.planEndDate | dateFormat}}</text>
                  </g>
                </g>
              </g>
            </g>
          </g> -->
          <g class="versions" *ngIf="versionsFlag">
            <g *ngFor="let v of versions; let i = index">
              <line class="line-white" [attr.x1]="versionsXPoints[i]?.x1" [attr.y1]="90.5+'%'" [attr.x2]="versionsXPoints[i]?.x2" [attr.y2]="0" [attr.stroke-dasharray]="v?.isLastVersion ? 0 : 12" [attr.stroke-width]="fullScreen ? 3 : 1"></line>

              <circle class="circle" [attr.cx]="versionsXPoints[i]?.x2" [attr.cy]="0" [attr.fill]="'#FFFFFF'"
                [attr.r]="fullScreen?5:3"></circle>
              <circle class="circle" [attr.cx]="versionsXPoints[i]?.x1" [attr.cy]="90.5+'%'" [attr.fill]="'#FFFFFF'"
                [attr.r]="fullScreen?5:3"></circle>

              <g id="hover-tooltip-first">
                <circle [attr.stroke]="'#FFFFFF'" [attr.cx]="versionsXPoints[i]?.x1" [attr.cy]="90.5+'%'"
                  [attr.stroke-width]="fullScreen?3:2" [attr.r]="fullScreen?8:5"></circle>
                <circle [attr.cx]="versionsXPoints[i]?.x1" [attr.cy]="90.5+'%'" [attr.fill]="'#FFFFFF'"
                  [attr.r]="fullScreen?5:3"></circle>
                <g transform="translate(10,0)">
                  <rect class="tooltip-rect" [attr.x]="versionsXPoints[i]?.x1" [attr.y]="75+'%'" [attr.height]="fullScreen?70:40"
                    [attr.width]="fullScreen?260:160" rx="3" ry="3"></rect>
                  <g transform="translate(2, 3)">
                    <text class="tooltip-text" [attr.x]="versionsXPoints[i]?.x1" [attr.y]="75+'%'" [attr.dy]="fullScreen?25:12"
                      [attr.dx]="fullScreen?10:5" text-anchor="start">Дата начало:</text>
                    <text class="tooltip-text" [attr.x]="versionsXPoints[i]?.x1" [attr.y]="75+'%'" [attr.dy]="fullScreen?25:12"
                      [attr.dx]="fullScreen?130:80" text-anchor="start">{{ v.planStartDate | dateFormat}}</text>
                    <text class="tooltip-text" [attr.x]="versionsXPoints[i]?.x1" [attr.y]="75+'%'" [attr.dy]="fullScreen?45:30"
                      [attr.dx]="fullScreen?10:5" text-anchor="start">Дата конца:</text>
                    <text class="tooltip-text" [attr.x]="versionsXPoints[i]?.x1" [attr.y]="75+'%'" [attr.dy]="fullScreen?45:30"
                      [attr.dx]="fullScreen?130:80" text-anchor="start">{{v.planEndDate | dateFormat}}</text>
                  </g>
                </g>
              </g>
              <g id="hover-tooltip-second">
                <circle [attr.stroke]="'#FFFFFF'" [attr.cx]="versionsXPoints[i]?.x2" [attr.cy]="0" [attr.stroke-width]="fullScreen?3:2"
                  [attr.r]="fullScreen?8:5"></circle>
                <circle [attr.cx]="versionsXPoints[i]?.x2" [attr.cy]="0" [attr.fill]="'#FFFFFF'" [attr.r]="fullScreen?5:3"></circle>
                <g [attr.transform]="getRectPosition(versionsXPoints[i]?.x2, 100)">
                  <line class="line-white" [attr.x1]="versionsXPoints[i]?.x2-xPos" [attr.y1]="-5" [attr.x2]="versionsXPoints[i]?.x2-xPos"
                    [attr.y2]="89+'%'" [attr.stroke-width]="fullScreen ? 2 : 1"></line>
                  <rect class="tooltip-rect" [attr.x]="versionsXPoints[i]?.x2" [attr.y]="2+'%'" [attr.height]="fullScreen?70:40"
                    [attr.width]="fullScreen?260:160" rx="3" ry="3"></rect>
                  <g transform="translate(2, 3)">
                    <text class="tooltip-text" [attr.x]="versionsXPoints[i]?.x2" [attr.y]="2+'%'" [attr.dy]="fullScreen?25:12"
                      [attr.dx]="fullScreen?10:5" text-anchor="start">Дата начало:</text>
                    <text class="tooltip-text" [attr.x]="versionsXPoints[i]?.x2" [attr.y]="2+'%'" [attr.dy]="fullScreen?25:12"
                      [attr.dx]="fullScreen?130:80" text-anchor="start">{{ v.planStartDate | dateFormat}}</text>
                    <text class="tooltip-text" [attr.x]="versionsXPoints[i]?.x2" [attr.y]="2+'%'" [attr.dy]="fullScreen?45:30"
                      [attr.dx]="fullScreen?10:5" text-anchor="start">Дата конца:</text>
                    <text class="tooltip-text" [attr.x]="versionsXPoints[i]?.x2" [attr.y]="2+'%'" [attr.dy]="fullScreen?45:30"
                      [attr.dx]="fullScreen?130:80" text-anchor="start">{{v.planEndDate | dateFormat}}</text>
                  </g>
                </g>
              </g>

             </g>
          </g>

        </g>
      </svg>
    </div>

    <div class="table-overlay" *ngIf="tableOpen" (click)="closeTableView()">
      <div class="table-block">
        <div class="table-block-close" title="Закрыть">
          <div class="modal_header_close" (click)="closeTableView()">✕</div>
        </div>
        <div class="table-header">
          <div class="title col1">Операции подразделов</div>
          <div class="title col2">Производственный показатель</div>
          <div class="title col3">Факт</div>
          <div class="title col4">План</div>
          <div class="title col5">Исполнение</div>
        </div>
        <div class="table-body">
          <div class="table-row" *ngFor="let item of buildingLevelStages">
            <div class="row-head col1"><span>{{item.title}}</span></div>
            <div class="row-td col2"><span>{{item.prodIndicatorTitle}}, {{item.unitTitle}}</span></div>
            <div class="row-td col3"><span>{{item.factValue}}</span></div>
            <div class="row-td col4"><span>{{item.planValue}}</span></div>
            <div class="row-td col5"><span>{{item.completionPercent}}%</span></div>
          </div>
        </div>
      </div>
    </div>

  </div>

</ng-container>
